import React from 'react';
import { withTranslation } from 'react-i18next';

import Tooltip from 'components/tooltip';

const AppChangelogButton = ({ t }) => {
    return (
        <Tooltip tooltip={t('What’s new') + '?'}>
            <a className="btn btn-solid btn-small app-bar-btn" href="https://changelog.niftypm.com" target="_blank" rel="noopener noreferrer">
                <span role="img" aria-label="party">🎉</span>
            </a>
        </Tooltip>
    )
}

export default withTranslation('settings')(AppChangelogButton);
